import { render, staticRenderFns } from "./headers.vue?vue&type=template&id=38c030f9&"
import script from "./headers.vue?vue&type=script&lang=js&"
export * from "./headers.vue?vue&type=script&lang=js&"
import style0 from "./headers.vue?vue&type=style&index=0&id=38c030f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports